module.exports = __webpack_public_path__ + "85ed8fcb4d605fa878de51fcab61f9fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/news/11/oskar_lindholm_ceo.jpg
// module id = 235
// module chunks = 0